import BaseService from "@client.services/baseService";

export default class GoogleService extends BaseService {
  constructor() {
    super("google", true);
  }

  async getAccessToken(request) {
    return super.post(`https://oauth2.googleapis.com/token`, request, true);
  }

  async getUserInfo(token) {
    return super.api(
      `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`,
      {},
      true
    );
  }

  async getAdminDirectoryInfo(email, token) {
    return super.api(
      `https://www.googleapis.com/admin/directory/v1/users/${email}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      true
    );
  }

  async uploadGroups(organizationId, customerId, token) {
    return super.api(`uploadGroups/${organizationId}`, {
      customerId,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }
}
